<template>
  <div id="categories">
    <Datatable
      v-if="inventory"
      entity="category"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id, company: company}"
      :onRowClick="onRowClick"
      :globalActions="[{text: 'categories.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit },
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}
      ]">
    </Datatable>

    <Modal
      name="delete-confirmation"
      :title="$t('categories.confirmation')"
      dismissable
      :actions="[{name: $t('back'), action: 'close'}, {name: $t('datatable.delete'), action: deleteCategoryAction, primary: true}]">
      <p>{{$t('categories.delete_message')}} <b>{{actionRow.name}}</b>?</p>
    </Modal>

  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import {mapActions} from "vuex";

  export default {
    name: "categories",

    components: { Datatable },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.categories";
      this.$store.state.pageIcon = "/icon/menu.svg";
    },

    data() {
      return {
        actionRow: {},
        entityName: 'categories'
      }
    },

    computed: {
      inventory() {
        return this.$store.state.contextInventory
      },
      company() {
        return this.$route.query.company || undefined;
      }
    },

    methods: {
      ...mapActions(["deleteInventoryEntity"]),

      onCreate() {
        this.$router.push(this.$router.buildContext('/category/edit'));
      },
      onRowClick(row) {
        this.$router.push(this.$router.buildContext('/items', {category: row.id}));
      },
      onRowEdit(row) {
        this.$router.push(this.$router.buildContext('/category/edit', {category: row.id}));
      },
      onRowDelete(row) {
        this.actionRow = row;
        this.$modal.show("delete-confirmation");
      },
      async deleteCategoryAction() {
        this.$store.commit("showSpinner", true);
        let response = await this.deleteInventoryEntity({entity: this.entityName, inventory: this.inventory.id, id: this.actionRow.id});
        if (response) {
          this.$modal.show("delete-confirmation", false);
          this.$refs.datatable.query();
          this.$store.commit("showSpinner", false);
        } else {
          this.$modal.show("delete-confirmation", false);
          toast(this.$t("error.no_server"),"error");
          this.$store.commit("showSpinner", false);
        }
      }
    }
  }

</script>

<style lang="scss" scoped>

</style>
